import { Select, SelectItem } from "@certn/cascadia-react";
import { Schemas } from "../../../types";
import { useTranslation } from "react-i18next";
import isNil from "lodash/isNil";

type BillingNetTermsProps = {
  testID?: string;
  net_terms?: Schemas["NetTermsEnum"];
  payment_method: Schemas["PaymentMethodEnum"];
};

/**
 * Displays the client's billing net terms.
 *
 * Net terms are only shown for clients who are not on credit card payments.
 * This component is read-only and does not allow updating the payment terms.
 */
export const BillingNetTerms = ({
  testID = "billing-information-net-terms",
  net_terms,
  payment_method,
}: BillingNetTermsProps) => {
  const { t } = useTranslation();
  const isCreditCard = payment_method === "CREDIT_CARD";

  if (isCreditCard || isNil(net_terms)) return null;

  const days = net_terms.split("_")[1];
  const options = [
    { id: net_terms, name: isNil(days) ? net_terms : `Net ${days}` },
  ];

  return (
    <Select
      isDisabled
      isRequired
      name="net_terms"
      label={t("Net Terms")}
      testID={testID}
      items={options}
      value={net_terms}
    >
      {options.map((option) => (
        <SelectItem key={option.id} id={option.id}>
          {option.name}
        </SelectItem>
      ))}
    </Select>
  );
};
